module.exports = __webpack_public_path__ + "img/cart.441d8411.svg";